import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BookOpenIcon, 
  CogIcon, 
  BeakerIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';
import { useAuthStore } from '../../stores/authStore';

const Libraries: React.FC = () => {
  const { user } = useAuthStore();
  const isConsultant = user?.roles?.includes('CONSULTANT');

  const libraries = [
    {
      id: 'exercises',
      name: 'Exercises',
      description: 'Exercise database',
      icon: BookOpenIcon,
      iconColor: 'text-blue-600',
      path: '/libraries/exercises'
    },
    {
      id: 'equipment',
      name: 'Equipment',
      description: 'Equipment inventory',
      icon: CogIcon,
      iconColor: 'text-green-600',
      path: '/libraries/equipment'
    },
    {
      id: 'foods',
      name: 'Foods',
      description: 'Nutrition database',
      icon: BeakerIcon,
      iconColor: 'text-purple-600',
      path: '/libraries/foods'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Header */}
      <div className="bg-white border-b border-gray-200 px-4 py-4">
        <h1 className="text-xl font-bold text-gray-900">Libraries</h1>
        <p className="text-sm text-gray-600 mt-1">
          Exercise, equipment & nutrition content
        </p>
      </div>

      {/* Library List */}
      <div className="bg-white divide-y divide-gray-100">
        {libraries.map((library) => (
          <Link
            key={library.id}
            to={library.path}
            className="flex items-center px-4 py-4 active:bg-gray-50 touch-manipulation"
          >
            <div className="flex-shrink-0 mr-3">
              <library.icon className={`h-6 w-6 ${library.iconColor}`} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-medium text-gray-900">{library.name}</h3>
              <p className="text-sm text-gray-500">{library.description}</p>
            </div>
            <ChevronRightIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
          </Link>
        ))}
      </div>

      {/* Quick Actions for Consultants */}
      {isConsultant && (
        <div className="mt-4 mx-4">
          <div className="bg-blue-50 rounded-lg p-4">
            <h3 className="text-sm font-medium text-blue-900 mb-3">
              Quick Add
            </h3>
            <div className="space-y-2">
              <button className="w-full text-left py-2 px-3 bg-white rounded-md text-sm text-blue-700 active:bg-blue-50">
                + Add Exercise
              </button>
              <button className="w-full text-left py-2 px-3 bg-white rounded-md text-sm text-green-700 active:bg-green-50">
                + Add Equipment
              </button>
              <button className="w-full text-left py-2 px-3 bg-white rounded-md text-sm text-purple-700 active:bg-purple-50">
                + Add Food
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Libraries;
